import { Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import formatCurrency from 'modules/core/lib/formatCurrency'
import { currencyToNumber, toCents } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

const isUndefinedNullOrEmpty = (s: string) => s === undefined || s === null || s === ''

const formatAmount = (amount: string) => formatCurrency(toCents(currencyToNumber(amount.trim())))

const Amount = ({
  amount,
  error,
  previousValue,
}: {
  amount: string
  error?: string
  previousValue?: string
}) => {
  const [open, toggle] = useToggle(false)

  // Despite the `amount` prop being typed as a string, it can be passed
  // any value typed as `any` (like null or a number) without TypeScript
  // complaining.

  if (error) {
    return (
      <Tooltip.Alt
        attachment="bottom center"
        targetAttachment="top center"
        toggle={toggle}
        open={open}
        label={error}
        backgroundColor="radicalRed1000"
      >
        <Text.Normal color="radicalRed1200">
          {isUndefinedNullOrEmpty(amount) ? '--' : amount}
        </Text.Normal>
      </Tooltip.Alt>
    )
  }

  if (isUndefinedNullOrEmpty(amount)) {
    return (
      <Text.Normal weight="medium" color="grey600">
        {i18n.t('payroll_bundle.payroll_results.not_imported')}
      </Text.Normal>
    )
  }

  const formattedAmount = formatAmount(String(amount))

  if (previousValue) {
    const label = (
      <>
        <Text.Normal weight="medium" stroked>
          {formatAmount(previousValue)}
        </Text.Normal>
        {' - '}
        <Text.Normal weight="medium">{formattedAmount}</Text.Normal>
      </>
    )

    return (
      <Tooltip.Alt attachment="top center" open={open} toggle={toggle} label={label}>
        <Text.Normal>{formattedAmount}</Text.Normal>
      </Tooltip.Alt>
    )
  }

  return <Text.Normal>{formattedAmount}</Text.Normal>
}

export default Amount
